<template>
    <el-select 
    size="small" 
    v-model="check_taxpayer_ids" 
    filterable 
    remote 
    :remote-method="remoteMethod" 
    clearable 
    multiple 
    placeholder="请选择" 
    @change="handleChange"
    @blur="handleBlur"
    @visible-change="remoteMethod('')" 
    :loading="loading">
        <el-option
            v-for="item in list"
            :key="item.id"
            :label="item.title"
            :value="item.taxpayer_id">
        </el-option>
    </el-select>
</template>


<script>
import CommonService from "~/services/common";

export default {
    name: "InvoiceSelect",
    props: {
        taxpayer_ids: {
            type: Array,
            default: function() {
                // 返回一个新的数组，而不是共享的引用
                return [];
            }
        },
    },
    data() {
        return {
            list: [],
            searcheModel: {},
            loading: false,
            check_taxpayer_ids: []
        };
    },

    created() {
        this.check_taxpayer_ids = this.taxpayer_ids;
        this.resetForm();
    },


    methods: {
        // 筛选查询
        submitSearch(params = null) {
            if(params){
                this.searcheModel = params;
            }
            params = _.clone(this.searcheModel);
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            //请求侧边栏地区树
            this.getList(params);
        },

        //重置按钮
        resetForm() {
            
            this.searcheModel = {
                title: '',
                fields: 'id,title,taxpayer_id',
                group: ['taxpayer_id'],
                perPage: 100,
                taxpayer_ids: this.check_taxpayer_ids
            };
            this.list = [];
            this.submitSearch(this.searcheModel);
        },

        getList(params = {}){
            // loading 动画
            this.loading = true;
            CommonService.getOrderInvoice(params)
            .then((res) => {
                if (res.code == 0) {
                    this.list = res.data;
                }
                this.loading = false;
            })
            .catch((err) => {
                this.loading = false;
                console.error(err);
            });
        },

        remoteMethod(query){
            this.getList({title: query});
        },

        handleChange(val){
            this.$emit("change", val);
        },
        
        handleBlur(event) {
            /**
             * 鼠标移除事件不需要触发。
             * 不然会出现我不选择修改值，会造成当前对象为空的想象。
             */
            console.log('handleBlur:', check_taxpayer_ids, event);
        },

        //对输入框进行重置     
        reset(){
            this.check_taxpayer_ids = [];
        }           
    }
}
</script>


// WEBPACK FOOTER //
// src/widgets/InvoiceSelect.vue